import { Brand, createBranded } from '@deltasierra/type-utilities';

export type TemplateMigrationId = Brand<number, 'TemplateMigrationId'>;
export const TemplateMigrationId = createBranded<TemplateMigrationId>();
